module.exports = __webpack_public_path__ + "b8039b29089feed10972d898adea8216.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/broschuere_image.jpg
// module id = 609
// module chunks = 0